import {getBuyerTotal, isAssignedTickets} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {FormStep} from '../../../constants'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {getGiftCardPaymentDetails} from '../../../selectors/invoice'
import {getNavigationQuery} from '../../../selectors/navigation'
import {getInvoice} from '../../../selectors/placed-order'
import {getReservationExpiration} from '../../../selectors/reservation'
import c from '../../classnames.scss'
import {FormButton} from '../../form-button/form-button'
import {FormSteps} from '../../form-steps'
import {Step} from '../../form-steps/interfaces'
import {Checkout} from '../index'
import {ReservationTimer} from '../reservation-timer'
import {CheckoutSummary} from './checkout-summary'
import s from './mobile-checkout.scss'

export const MobileCheckout = () => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const {
    openTimeExpiredModal,
    formPageLoaded,
    closeNativeModal,
    scrollToElement,
    getCheckoutData,
    navigateBack,
    openTicketsDetailsModal,
  } = useAppActions()

  const event = useAppSelector(getEvent)
  const reservationExpiration = useAppSelector(getReservationExpiration)
  const invoice = useAppSelector(getInvoice)
  const giftCardPaymentDetails = useAppSelector(getGiftCardPaymentDetails)
  const query = useAppSelector(getNavigationQuery)
  const buyerTotal = getBuyerTotal(invoice.grandTotal, giftCardPaymentDetails)

  useEffect(() => {
    if (isAssignedTickets(event) && query?.orderNumber) {
      navigateBack()
    }

    if (query?.reservationId) {
      getCheckoutData({eventId: event.id, reservationId: query.reservationId, orderNumber: query.orderNumber})
    }
  }, [])

  useEffect(() => {
    formPageLoaded(true)
    closeNativeModal()
  }, [formPageLoaded, closeNativeModal])

  const isCheckoutReady = (steps: Step[]) => steps.every(step => step.completed)

  const openTicketDetails = () => openTicketsDetailsModal()

  return (
    <Checkout isMobile={isMobile}>
      {(steps: Step[], currentStep: FormStep, pay: Function) => (
        <div className={classNames(s.container, c.formBackgroundColor)}>
          <div className={s.stack}>
            <ReservationTimer
              expires={reservationExpiration}
              onExpire={openTimeExpiredModal}
              t={t}
              isMobile={isMobile}
            />
            <CheckoutSummary onViewAllItems={openTicketDetails} currentStep={currentStep} buyerTotal={buyerTotal} />
          </div>
          <FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />
          {isCheckoutReady(steps) && Number(buyerTotal.amount) > 0 ? (
            <div className={s.button}>
              <FormButton
                text={t('mobile.checkout.placeOrder')}
                type="submit"
                dataHook={DH.CHECKOUT_BUTTON}
                onClick={pay}
              />
            </div>
          ) : null}
        </div>
      )}
    </Checkout>
  )
}
